import Axios from "axios";

const defaultAxios = Axios.create({
  baseURL: process.env.REACT_APP_API,
});

defaultAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("admintoken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default defaultAxios;
